// 工場ギャラリー: ループスライダー + dialog モーダル
// インラインのスライドボタンをクリックするとモーダルが開き、同インデックスから閲覧可能。

(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c_factory-gallery').forEach((section) => {
      if (section.dataset.factoryGalleryInited === 'true') return;
      section.dataset.factoryGalleryInited = 'true';
      initSlider(section);
      initModal(section);
    });
  });

  // ==================================================
  // インラインスライダー
  // ==================================================
  function initSlider(section) {
    const inlineEl = section.querySelector('[data-factory-gallery-inline]');
    if (!inlineEl) return;
    if (typeof Splide === 'undefined') return;

    const splide = new Splide(inlineEl, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      focus: 'center',
      gap: 20,
      padding: '4%',
      pagination: false,
      arrows: true,
      breakpoints: {
        999: {
          perPage: 2,
          padding: '5%',
        },
        740: {
          perPage: 1,
          gap: 10,
          padding: '15%',
          arrows: false,
        },
      },
    });
    splide.mount();
  }

  // ==================================================
  // モーダル（dialog）
  // ==================================================
  function initModal(section) {
    const dialog = section.querySelector('[data-factory-gallery-dialog]');
    const modalEl = section.querySelector('[data-factory-gallery-modal]');
    if (!dialog || !modalEl) return;
    if (typeof Splide === 'undefined') return;

    const openButtons = section.querySelectorAll('[data-factory-gallery-open]');
    const closeButton = section.querySelector('[data-factory-gallery-close]');

    let modalSplide = null;

    const ensureModalMounted = () => {
      if (modalSplide) return;
      modalSplide = new Splide(modalEl, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: 20,
        fixedWidth: 720,
        focus: 'center',
        pagination: false,
        arrows: true,
        breakpoints: {
          740: {
            fixedWidth: '100%',
            gap: 0,
            pagination: true,
            focus: 0,
          },
        },
      });
      modalSplide.mount();
    };

    const lockBodyScroll = () => {
      const scrollY = window.scrollY;
      document.body.dataset.factoryGalleryLockedScroll = String(scrollY);
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('c_factory-gallery--locked');
    };

    const unlockBodyScroll = () => {
      const lockedScroll = parseFloat(document.body.dataset.factoryGalleryLockedScroll || '0');
      document.body.classList.remove('c_factory-gallery--locked');
      document.body.style.top = '';
      delete document.body.dataset.factoryGalleryLockedScroll;
      window.scrollTo(0, lockedScroll);
    };

    const openModal = (index) => {
      dialog.showModal();
      lockBodyScroll();

      requestAnimationFrame(() => {
        ensureModalMounted();
        if (modalSplide) {
          modalSplide.refresh();
          if (typeof index === 'number') {
            modalSplide.go(index);
          }
        }
      });
    };

    const closeModal = () => {
      dialog.close();
      unlockBodyScroll();
    };

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.index || '0', 10) || 0;
        openModal(idx);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    dialog.addEventListener('click', (event) => {
      // スライド本体・閉じるボタン・アロー・ページネーション以外のクリックで閉じる
      const isInteractive = event.target.closest(
        '.c_factory-gallery__dialog-slide, .c_factory-gallery__dialog-close, .splide__arrow, .splide__pagination__page'
      );
      if (!isInteractive) {
        closeModal();
      }
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });
  }
})();
